var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4e211;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scribble_3",
    "data-name": "scribble 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1056.8,348.61c-11.35-27.66-29-53.85-54.81-69s-60.62-17-84.67.75-31.26,56.82-10.89,78.7C873.75,312.14,839.49,263.71,790,235s-118.82-31.64-159.22,8.85c-34,34.13-38.28,89.65-23,135.39s46.6,84.06,77.3,121.23c-29.5-29.47-85.62-24.23-109.17,10.18S567.79,599.29,606,616.11c-40.71-21.23-94.33-9.34-126.31,23.6s-42.81,83.21-32.83,128c6.31,28.34,20.33,54.78,38.92,77,26.53,31.66,34.73,20.23,52.28-11.51,28.22-51,59.09-100.17,94.53-146.55A1120.19,1120.19,0,0,1,884.08,446.41,1086.4,1086.4,0,0,1,1056.8,348.61Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects28);
export default __webpack_public_path__ + "static/media/objects-28.92e502e61c9ea570d848823fe0ebd8b4.svg";
export { ForwardRef as ReactComponent };